/** Per-serving macro helpers shared by cards, previews and the Recommend tray. */

import type { Ingredient } from '@/api/types'

export interface Macros {
  kcal: number | null
  protein: number | null
  carbs: number | null
  fat: number | null
}

/** Per-serving macros from a recipe summary. */
export function summaryMacros(recipe: {
  kcal_per_serving: number | null
  protein_per_serving: number | null
  carbs_per_serving: number | null
  fat_per_serving: number | null
}): Macros {
  return {
    kcal: recipe.kcal_per_serving,
    protein: recipe.protein_per_serving,
    carbs: recipe.carbs_per_serving,
    fat: recipe.fat_per_serving,
  }
}

/** One serving of each recipe added up. Unknown stays unknown. */
export function addMacros(a: Macros, b: Macros): Macros {
  const add = (x: number | null, y: number | null) => (x === null || y === null ? null : x + y)
  return {
    kcal: add(a.kcal, b.kcal),
    protein: add(a.protein, b.protein),
    carbs: add(a.carbs, b.carbs),
    fat: add(a.fat, b.fat),
  }
}

/** An ingredient counts as tracked if it carries any macro at all. */
export function isTracked(ingredient: Ingredient | null): boolean {
  return (
    ingredient !== null &&
    (ingredient.calories !== null ||
      ingredient.protein !== null ||
      ingredient.carbs !== null ||
      ingredient.fat !== null ||
      ingredient.fiber !== null)
  )
}
